import React from "react";
import Lottie from "react-lottie-player";

import data from "./prediction-job-animation.json";

const defaultOptions = {
  loop: true,
  play: true,
  animationData: data,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  },
  style: { width: "200px" }
};

const PredictionJobAnimation: React.FC = () => {
  return <Lottie {...defaultOptions} />;
};

export default PredictionJobAnimation;
